import { ref } from 'vue';
import type { Channels } from '@eureka/shared/src/login-sdk';
import { initLoginSdk } from '@/utils/login-sdk-utils';

export function useLoginSdk() {
    // 响应式状态：是否正在登录流程中
    const isLoginDialogOpen = ref(false);

    // 初始化登录 SDK（纯 TS 工具函数）
    const { openLoginDialog: _openLoginDialog } = initLoginSdk();

    /**
     * 打开登录对话框（带状态管理）
     * @param withoutClose - 是否禁用关闭按钮（默认 true）
     * @param customChannels - 自定义渠道参数（可选）
     * @returns Promise - 登录成功且应用重新初始化完成后 resolve
     */
    const openLoginDialog = async (withoutClose = true, customChannels?: Channels): Promise<void> => {
        // 如果已经在登录流程中，避免重复打开
        if (isLoginDialogOpen.value) {
            return;
        }

        try {
            // 标记开始登录
            isLoginDialogOpen.value = true;

            // 调用底层登录方法
            await _openLoginDialog(withoutClose, customChannels);
        } finally {
            // 无论成功或失败，都重置状态
            isLoginDialogOpen.value = false;
        }
    };

    return {
        /** 是否正在登录流程中（包括弹窗显示和 reinit 过程） */
        isLoginDialogOpen,
        /** 打开登录对话框 */
        openLoginDialog,
    };
}
